import { unstable_generateUtilityClass as generateUtilityClass, unstable_generateUtilityClasses as generateUtilityClasses } from '@mui/utils';
export const getPickersFadeTransitionGroupUtilityClass = slot => generateUtilityClass('MuiPickersFadeTransitionGroup', slot);
export const pickersFadeTransitionGroupClasses = generateUtilityClasses('MuiPickersFadeTransitionGroup', ['root']);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/x-date-pickers/DateCalendar/pickersFadeTransitionGroupClasses.js
// module id = 1344
// module chunks = 0